"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LivePreviewApiSymbol = exports.ControllersInvokerSymbol = exports.LivePreviewEnvDataSetterSymbol = exports.PlatformResetCompsSymbol = void 0;
exports.PlatformResetCompsSymbol = Symbol('PlatformResetComps');
exports.LivePreviewEnvDataSetterSymbol = Symbol('LivePreviewEnvDataSetterSymbol');
exports.ControllersInvokerSymbol = Symbol('ControllersInvoker');
exports.LivePreviewApiSymbol = Symbol('livePreviewApi');
//# sourceMappingURL=platform.js.map